import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { PartyUidSchema } from './general';

/**
 * Database schema for manual participants
 */
export type ManualParticipants = Static<typeof ManualParticipantsSchema>;
export const ManualParticipantsSchema = Type.Object(
  {
    id: Type.String(),
    retailUnit: Type.String({ minLength: 2, maxLength: 2 }),
    lotteryId: Type.String(),
    partyUid: PartyUidSchema,
    timestamp: Type.String({ format: 'date-time' }),
    addedBy: Type.String(),
    entryDate: Type.String({ format: 'date' }),
    type: Type.Union([Type.Literal('INSERT'), Type.Literal('DELETE')]),
  },
  { additionalProperties: false, $id: 'ManualParticipantsSchema' }
);

export type Participant = Static<typeof ParticipantSchema>;
export const ParticipantSchema = Type.Object(
  {
    partyUid: PartyUidSchema,
    entryDate: Type.String({ format: 'date' }),
    optedOut: Type.Optional(Type.Boolean()),
  },
  { $id: 'ParticipantSchema' }
);

export type Participants = Static<typeof ParticipantsSchema>;
export const ParticipantsSchema = Type.Array(ParticipantSchema, { $id: 'ParticipantsSchema' });
